export class ScreenResolutionManager {

    constructor() {
        $(document).ready(() => {
            $('#loginScreenResolution').val(screen.width + 'x' + screen.height);
        });
    }
}